import { render, staticRenderFns } from "./ProjSelect.vue?vue&type=template&id=a952dab2&scoped=true&"
import script from "./ProjSelect.vue?vue&type=script&lang=js&"
export * from "./ProjSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a952dab2",
  null
  
)

export default component.exports